<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Bag Pit Type"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedBagPitTypes"
      :columns="columns"
      :total-rows="totalBagPitTypes"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'BagPitTypeTable',
  components: {
    BaseTable
  },
  data() {
    return {
      bagPitTypes: [],
      totalBagPitTypes: 0,
      columns: [
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'description', align: 'left', label: 'Description', field: 'description', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedBagPitTypes() {
      return this.bagPitTypes.map(type => ({
        ...type,
        add_date: new Date(type.add_date).toLocaleDateString(),
        edit_date: new Date(type.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchBagPitTypes();
  },
  methods: {
    fetchBagPitTypes() {
      axios
        .get('/api/v1/bag_pit_type/bag_pit_types/')
        .then(response => {
          this.bagPitTypes = response.data;
          this.totalBagPitTypes = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching bag pit types:', error);
        });
    },
    onAdd() {
      this.$router.push('/bag_pit_type/add');
    },
    getEditUrl(row) {
      return `/bag_pit_type/edit/${row.id}`;
    }
  },
  watch: {
    bagPitTypes() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the BagPitTypeTable here */
</style>
